import { createAsyncThunk } from "infrastructure/store/lib";
import type { AsyncThunk, RootState } from "infrastructure/store";
import { ApiState } from "infrastructure/api";
import type { ThunkReturnType } from "types";
import { ApiRouteTypes } from "consts/enpoints/api";
import { payloadCreator } from "util/api";
import { concat } from "util/support";
import { sliceToken } from "./state";
import type { PaymentMethodsResponse } from "./types";
import { getPaymentMethods } from "./api";

export const getPaymentMethodsThunk: AsyncThunk<
    ThunkReturnType<PaymentMethodsResponse>,
    string | undefined,
    {}
> = createAsyncThunk(
    concat([sliceToken, ApiRouteTypes.GetPaymentMethods]),
    payloadCreator(getPaymentMethods),
    {
        condition: (_, { getState }) => {
            const { paymentMethods } = getState() as RootState;
            return (
                !paymentMethods.paymentMethodsSlice &&
                ![ApiState.Pending].includes(paymentMethods.paymentMethodsLoadingState)
            );
        }
    }
);
